import { Component } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [NgIf]
})
export class HeaderComponent {
  environmentName = environment.name;
  version = environment.uivn;
}
